import COUNTRIES_NAMES from './countriesNames';
import GENDER_TYPES from './genderTypes';

export default {
  COUNTRIES_NAMES,
  GENDER_TYPES,
};
